<template>
  <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast" @blur="closeModal">
    <div class="uk-modal-dialog tm-func-modal" v-click-outside="closeModal">
      <!--Название-->
      <div class="uk-modal-header">
        <div class="tm-background-green uk-padding-xsmall uk-position-top-right uk-text-bold tm-light 5"
             style="cursor: pointer;"
             @click="closeModal()">
          <md-icon>close</md-icon>
        </div>
        <div class="uk-modal-title">
          <div data-uk-grid class="uk-grid uk-flex-middle uk-grid-small">
            <div v-if="capacity && capacity.name">
              {{ capacity.name }}
            </div>
            <template v-else>
              <div>
                Новый усилитель функции
              </div>
              <div>
                <input :class="'uk-input '+ (functionErrors['name'] ? ' uk-form-danger ' : '')"
                       v-model="newCapacity.name"
                       type="text">
              </div>
              <div class="uk-text-small uk-text-muted">
                Все новые усилители будут созданы для подкатегории "Capacity"
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="uk-modal-body">
        <div class="v-tabs tm-tabs theme--light">
          <!--Описание-->
          <template>
            <div class="uk-width-1-1">
              <v-tabs class="tm-tabs" v-model="tab">
                <v-tab v-for="(languages, LKey) of newCapacity.translations" :key="LKey"
                       :class="functionErrors['translations.'+LKey+'.text'] ? 'tm-val-error' : ''">
                  {{ languages.lang_name }}
                </v-tab>
              </v-tabs>
              <v-tabs-items class="tm-tabs-content" v-model="tab">
                <v-tab-item
                    v-for="(languages, key) of newCapacity.translations"
                    :key="key">
                  <v-card flat>
                    <v-card-text>
                      <div class="uk-margin-xsmall uk-text-small">Название усилителя</div>
                      <div class="uk-margin-xsmall">
                        <input
                            :class="'uk-input '+ (functionErrors['translations.'+key+'.text'] ? ' uk-form-danger ' : '')"
                            type="text" v-model="newCapacity.translations[key].text">
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </template>
          <div class="uk-width-1-1 uk-margin-medium-top">
            <button class="uk-button tm-button-success"
                    type="button"
                    @click="saveCapacity()">
              Сохранить
              <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>


import axios from "axios";

const url = process.env.VUE_APP_API_BASE_URL;

export default {
  props: {
    capacity: Object,
    languagesList: Array,
  },
  data() {
    return {
      tab: '',
      tabDataTranslates: [],
      loading: false,
      newCapacity: {
        name: this.capacity ? this.capacity.name : "",
        translations: [],
      },
      functionErrors: {},
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    getTranslatedName(object, language_id) {
      let translated = object.filter(function (lang) {
        return lang.language_id === language_id;
      });
      if (translated[0] && translated[0].name) {
        return translated[0].name;
      } else {
        return "";
      }
    },
    async saveCapacity() {
      this.loading = true;
      let data = this.newCapacity;

      await axios.post(`${url}/func/capacity`, data).then(async response => {
        await this.$store.dispatch('functionsEdit/functionsList');
        UIkit.notification({message: 'Capacity is saved', pos: 'top-center', status: 'success', timeout: 1500})
        this.$emit('reload');
        this.$emit('close');
      }).catch(err => {
        if (err.response.data && err.response.data.errors) {
          this.functionErrors = err.response.data.errors;
        }
        UIkit.notification({
          message: "Capacity isn't saved." + err.response.data.message ?? '',
          pos: 'top-center',
          status: 'error',
          timeout: 1500
        })
      });
      this.loading = false;
    },
    getCapacityData() {
      let result = {};
      let localizations = null;
      if (this.capacity && this.capacity.local_key && this.capacity.local_key.localizations) {
        localizations = this.capacity.local_key.localizations;
      }
      result = this.languagesList.map((lang) => {
        if (localizations) {
          let selectedLocale = localizations.filter((locale) => {
            return locale.id_languages === lang.id;
          });
          if (selectedLocale[0]) {
            selectedLocale[0].lang_name = lang.name;
            return selectedLocale[0];
          }
          return {id_languages: lang.id, text: '', lang_name: lang.name};
        } else {
          return {id_languages: lang.id, text: '', lang_name: lang.name};
        }
      });
      return result;
    }

  },
  async created() {
    this.tabDataTranslates = [];
    this.newCapacity.translations = this.getCapacityData();
  }
}
</script>